import { render, staticRenderFns } from "./AddPromotionTypeModal.vue?vue&type=template&id=d2cdcebe"
import script from "./AddPromotionTypeModal.vue?vue&type=script&lang=js"
export * from "./AddPromotionTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports